import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import Loader from '@/components/loader/Loader';

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('Loader', Loader)
